<div class="container__niveis" *ngIf="idNivel != 9 && idNivel != 10">
  <p id="boasVindas" class="niveis__text">
    Você é nosso <span class="nivel">{{ legenda | lowercase }} </span
    ><span class="coracao"><3</span>
  </p>
  <div class="niveis__descricao">
    <div class="container__pontos">
      <img
        class="pontos__img"
        src="assets/images/icons/pontos.svg"
        alt="Pontos"
      />
      <p class="pontos__text">
        {{ valorAtual }} {{ valorAtual > 1 ? "pontos" : "ponto" }}
      </p>
    </div>
    <div class="entenda__niveis" *ngIf="screenWidth > 645" (click)="abrirEntendaNiveis()">
      <p class="entenda__niveis__link">{{ obterTextoLink() }}</p>
      <img class="flecha" src="assets/images/icons/flecha.svg" alt="Flecha" />
    </div>
  </div>
  <div
    class="bar"
    [style]="obterTextoNivelRange()"
    [ngClass]="{
      'bar--crush': calcularPorcentagem() < 33,
      'bar--paquera': calcularPorcentagem() >= 33 && calcularPorcentagem() < 66,
      'bar--paixao': calcularPorcentagem() >= 66 && calcularPorcentagem() < 100,
      'bar--amor': calcularPorcentagem() >= 100
    }"
  ></div>
  <div class="nome__niveis">
    <p [ngClass]="{ 'nivel--ativo': idNivel == 5 }">crush</p>
    <p [ngClass]="{ 'nivel--ativo': idNivel == 6 }">paquera</p>
    <p [ngClass]="{ 'nivel--ativo': idNivel == 7 }">paixão</p>
    <p [ngClass]="{ 'nivel--ativo': idNivel == 8 }">amor</p>
  </div>
  <div class="entenda__niveis entenda__niveis__mobile" *ngIf="screenWidth <= 645" (click)="abrirEntendaNiveis()">
    <p class="entenda__niveis__link">{{ obterTextoLink() }}</p>
    <img class="flecha" src="assets/images/icons/flecha.svg" alt="Flecha" />
  </div>
</div>
<p class="niveis__text legenda--nivel" [ngClass]="{'ajuste--embixador': idNivel == 10}" *ngIf="screenWidth <= 645 && (idNivel == 9 || idNivel == 10) ">
  Você é nosso <span class="nivel">{{ legenda | lowercase }} </span
  ><span class="coracao"><3</span>
</p>
<div class="container__nivel__mozao" *ngIf="idNivel == 9">
  <div class="mozao__esquerdo">
    <img
      *ngIf="screenWidth <= 645"
      src="assets/images/icons/icone__coracao.svg"
      alt="Coração"
    />
    <p *ngIf="screenWidth > 645">Você é nosso</p>
    <span class="nivel" *ngIf="screenWidth > 645"
      >{{ legenda | lowercase }} <span class="coracao"> <3</span></span
    >
  </div>
  <div class="mozao__direito">
    <p>Você está no nível mais avançado em nosso relacionamento!</p>
    <p>Aproveite todos os momentos especiais.</p>
  </div>
</div>

<div class="container__nivel__embaixador" *ngIf="idNivel == 10">
  <div class="embaixador__esquerdo">
    <img
      *ngIf="screenWidth <= 645"
      src="assets/images/icons/icone__coracao.svg"
      alt="Coração"
    />
    <p *ngIf="screenWidth > 645">Você é nosso</p>
    <span class="nivel" *ngIf="screenWidth > 645"
      >{{ legenda | lowercase }} <span class="coracao"> <3</span></span
    >
  </div>
  <div class="embaixador__direito">
    <p>Você é nosso Embaixador Lovers </p>
    <p>Neste nível somos 1 só, já podemos usar aliança?</p>
  </div>
</div>
